@media (min-width: 960px) {
  .galv-cuts {
    display: flex;
  }
}
.galv-cuts > form {
  overflow-x: scroll;
}
.galv-cuts > form,
.galv-cuts > fieldset {
  flex-basis: 50%;
  flex-grow: 1;
}
.galv-cuts .btn-group {
  text-align: right;
}
.galv-cuts .btn-group .disabled {
  background-color: #c9c9c9;
}
.galv-cuts .btn-group .btn-cta {
  font-size: 1rem;
  margin-right: 0.5rem;
}
.galv-cuts .table {
  width: 100%;
}

.tube-svg svg {
  height: auto;
  width: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInR1YmUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDRTtFQURGO0lBRUk7OztBQUdGO0VBQ0U7O0FBR0Y7QUFBQTtFQUVFO0VBQ0E7O0FBR0Y7RUFDRTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7RUFDQTs7QUFJSjtFQUNFOzs7QUFJSjtFQUNFO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIuZ2Fsdi1jdXRzIHtcbiAgQG1lZGlhIChtaW4td2lkdGg6IDk2MHB4KSB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgfVxuXG4gID4gZm9ybSB7XG4gICAgb3ZlcmZsb3cteDogc2Nyb2xsO1xuICB9XG5cbiAgPiBmb3JtLFxuICA+IGZpZWxkc2V0IHtcbiAgICBmbGV4LWJhc2lzOiA1MCU7XG4gICAgZmxleC1ncm93OiAxO1xuICB9XG5cbiAgLmJ0bi1ncm91cCB7XG4gICAgdGV4dC1hbGlnbjogcmlnaHQ7XG5cbiAgICAuZGlzYWJsZWQge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogI2M5YzljOTtcbiAgICB9XG5cbiAgICAuYnRuLWN0YSB7XG4gICAgICBmb250LXNpemU6IDFyZW07XG4gICAgICBtYXJnaW4tcmlnaHQ6IDAuNXJlbTtcbiAgICB9XG4gIH1cblxuICAudGFibGUge1xuICAgIHdpZHRoOiAxMDAlO1xuICB9XG59XG5cbi50dWJlLXN2ZyBzdmcge1xuICBoZWlnaHQ6IGF1dG87XG4gIHdpZHRoOiAxMDAlO1xufVxuIl19 */